import styled from 'styled-components';
import { IconButton } from "@material-ui/core";
import { Send, Mic } from "@material-ui/icons";
import Editor from 'draft-js-plugins-editor';
import { TextInputProps } from "./index";

export const EditorWrapper = styled.div`
  background-color: #fff;
  color: white;
  padding: 0px 12px 0px 12px;
  flex: 1 1 auto;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  min-width: 0;
  outline: none;
  width: 85%;
  max-height: 100%;
  overflow-y: scroll;
  will-change: width;
`;

export const StyledEditor = styled(Editor)`
  padding: 0;
  padding-right: 2px;
  font-size: 15px;
  font-weight: 400;
  max-height: 100px;
  min-height: 20px;
  outline: none;
  overflow-x: hidden;
  overflow-y: scroll;
  white-space: pre-wrap;
  color: #4a4a4a;
  width: 100%;
  user-select: text;
`;

export const SendButton = styled(IconButton)`
  height: 100%;
  width: 15%;
  background-color:green;
  && {
    &:hover{
      background-color: white;
    }
  }
`;

export const SendIcon = styled(Send)`
  font-size: 18px;
  color: black;
`;

export const MicIcon = styled(Mic)`
  font-size: 18px;
  color: black;
`;

export const Container = styled.div<{styles?: TextInputProps}>`
  background-color: ${props => props.styles?.backgroundColor};
  ${EditorWrapper} {
    background-color: ${props => props.styles?.backgroundColor};
    color: ${props => props.styles?.textColor};
  }
  ${SendButton} {
    &:hover{
      background-color: ${props => props.styles?.backgroundColor};
    }
  }
  & .public-DraftEditorPlaceholder-root {
    color: ${props => props.styles?.placeholderColor};
  }
  ${SendIcon} {
    color: ${props => props.styles?.sendIconColor};
  }
  ${MicIcon} {
    color: ${props => props.styles?.sendIconColor};
  }
  height: 50px;
  display: flex;
  align-items: center;
`;

export const SendContainer = styled.div<{ active?: boolean, animate?: boolean }>`
  padding: 5px 10px;
  flex: none;
  min-height: 52px;
  width: ${props => props.active ? '220px' : '44px'};
  display: flex;
  animation: ${props => props.animate ?
    (props.active ? 'width-increase .3s ease-in' : 'width-decrease .3s linear') : ''
  };
`;
